module.exports = __webpack_public_path__ + "img/KarteMLCv2.1dab9763.jpg";